import React from 'react';
import { Link } from 'react-router-dom';

function TitlesList(props) {
  return (
    <li>
        <div>
        <Link className='title' to={`/post/${props.id}`} target='_top'>
        <p>{props.title}</p>
        </Link>
        </div>
      </li>
  )
}

export default TitlesList